module.exports = {"540174400":"达孜县工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540174.json
// module id = 2686
// module chunks = 0